#edr-sensor-general-info-text {
  color: var(--body-text-arrows-400);
}
